var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEcoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07628 11.6854C6.07628 12.1122 6.45188 12.0411 6.63962 12.0411C7.203 12.0411 7.203 11.5076 7.203 11.3298L7.01522 9.37368C7.76634 6.17281 9.26857 5.40209 10.0197 4.92801C9.45623 5.28364 8.89314 6.35061 8.89314 7.23977C11.8975 7.23977 12.0853 2.79408 12.0853 2.79408C7.42834 3.22087 6.95275 5.34293 7.3909 6.35061L6.63962 7.4176L5.70076 5.46149C6.82744 0.660156 0.0673828 0.660156 0.0673828 0.660156C0.255102 5.8171 2.8842 6.35064 4.01087 6.17281C3.82309 4.21671 3.25976 3.32758 3.25976 3.32758C6.07628 6.17265 6.07628 11.1514 6.07628 11.6853V11.6854Z",
    fill: "#2DB875"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEcoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eco-icon.964329eebb9a571a5c2acdd66eb8568a.svg";